module.exports = __webpack_public_path__ + "static/sample-8-cdb9272357c0ec323bcb8dbee44c0bfd.png";